"use strict";

var _interopRequireWildcard = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Paging = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _slicedToArray2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _chevronRight = require("../../../assets/icons/chevron-right.svg");
var _chevronLeft = require("../../../assets/icons/chevron-left.svg");
var _getPages = require("./utils/getPages");
var _pagingModule = _interopRequireDefault(require("./paging.module.scss"));
var Paging = function Paging(_ref) {
  var totalPages = _ref.totalPages,
    _ref$page = _ref.page,
    page = _ref$page === void 0 ? 1 : _ref$page,
    changeCurrentPage = _ref.changeCurrentPage;
  var _useState = (0, _react.useState)(page),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    currentPage = _useState2[0],
    setCurrentPage = _useState2[1];
  var previousDisabled = currentPage === 1;
  var nextDisabled = currentPage === totalPages;
  var goTo = function goTo(page) {
    setCurrentPage(page);
    changeCurrentPage(page);
  };
  var goPrevious = function goPrevious() {
    if (!previousDisabled) {
      goTo(currentPage - 1);
    }
  };
  var goNext = function goNext() {
    if (!nextDisabled) {
      goTo(currentPage + 1);
    }
  };
  var onEnterNavigation = function onEnterNavigation(page) {
    return function (e) {
      if (e.key === 'Enter') {
        onNavigate(page);
      }
    };
  };
  var onNavigate = function onNavigate(p) {
    switch (p) {
      case 'jump-left':
        goTo(currentPage - 3);
        return;
      case 'jump-right':
        goTo(currentPage + 3);
        return;
      default:
        goTo(p);
        return;
    }
  };
  var getElement = function getElement(p) {
    return typeof p === 'number' ? p : '...';
  };
  (0, _react.useEffect)(function () {
    if (page !== currentPage) {
      setCurrentPage(page);
    }
  }, [currentPage, page]);
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: _pagingModule.default['paging'],
    "data-testid": "paging"
  }, /*#__PURE__*/_react.default.createElement("li", {
    className: _pagingModule.default['paging__page'],
    onClick: goPrevious,
    tabIndex: previousDisabled ? undefined : 0,
    onKeyUp: onEnterNavigation(currentPage - 1),
    "aria-disabled": previousDisabled
  }, /*#__PURE__*/_react.default.createElement(_chevronLeft.ReactComponent, {
    "data-testid": "previous-page-chevron",
    className: (0, _classnames.default)(_pagingModule.default['paging__navigation-chevron'], (0, _defineProperty2.default)({}, _pagingModule.default['paging__navigation-chevron--disabled'], previousDisabled))
  })), (0, _getPages.getPages)(currentPage, totalPages).map(function (p) {
    return /*#__PURE__*/_react.default.createElement("li", {
      "data-testid": "page-link-".concat(p),
      tabIndex: 0,
      key: p,
      onKeyUp: onEnterNavigation(p),
      className: (0, _classnames.default)(_pagingModule.default['paging__page'], (0, _defineProperty2.default)({}, _pagingModule.default['paging__page--active'], p === currentPage)),
      onClick: function onClick() {
        return onNavigate(p);
      }
    }, /*#__PURE__*/_react.default.createElement("a", {
      role: "button"
    }, getElement(p)));
  }), /*#__PURE__*/_react.default.createElement("li", {
    className: _pagingModule.default['paging__page'],
    onClick: goNext,
    onKeyUp: onEnterNavigation(currentPage + 1),
    tabIndex: nextDisabled ? undefined : 0,
    "aria-disabled": nextDisabled
  }, /*#__PURE__*/_react.default.createElement(_chevronRight.ReactComponent, {
    "data-testid": "next-page-chevron",
    className: (0, _classnames.default)(_pagingModule.default['paging__navigation-chevron'], (0, _defineProperty2.default)({}, _pagingModule.default['paging__navigation-chevron--disabled'], nextDisabled))
  })));
};
exports.Paging = Paging;
var Loading = function Loading() {
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: _pagingModule.default['paging'],
    "data-testid": "loading-paging"
  }, Array(_getPages.NUMBER_OF_PAGE_LINKS).fill(undefined).map(function (_, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index,
      "data-testid": "loading-link",
      className: _pagingModule.default['paging__page']
    });
  }));
};
Paging.Loading = Loading;